<template>
  <div class="history">
    <div class="history-content">
      <div class="images">
        <img
          :src="this.publicData.serverUrl + 'images/history@2x.png'"
          alt=""
        />
      </div>
      <div class="history-content-text">
        <h3>{{ $t('lang.mz.two.cj_child.title') }}</h3>
        <div class="scroll">
          {{ $t('lang.mz.two.cj_child.content') }}
        </div>
      </div>
    </div>
    <div class="history-btns">
      <div class="btn">{{ $t('lang.mz.two.cj_child.next') }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'history'
}
</script>

<style lang="scss" scoped>
.history {
  width: 100%;
  height: 100%;
  background: #ffffff;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  &-content {
    width: 100%;
    height: calc(100% - 30px - 6vh);
    flex: 1;
    padding: 25px;
    display: flex;
    justify-content: space-between;
    border: 1px solid #f0e9db;
    .images {
      display: flex;
      justify-content: center;
      width: 60%;
      height: 100%;
      img {
        max-width: 100%;
        max-height: 100%;
      }
    }
    &-text {
      width: 40%;
      height: 100%;
      padding-left: 30px;
      h3 {
        font-size: 1.1145vw;
        text-align: center;
        color: var(--exp-color);
        margin-top: 0;
      }
      .scroll {
        max-height: calc(100% - 60px);
        padding-right: 1rem;
        text-indent: 2rem;
        text-align: justify;
        margin: 0;
      }
    }
  }
  &-btns {
    margin: 3vh 0;
    display: flex;
    justify-content: center;
  }
}
</style>
